import React, {Component} from 'react'

class MusicAlgoFooter extends Component {
    render() {
        return (
            <div className="footer" style={{textAlign:"left"}}>Copyright &copy; 2018 MusicAlgo.</div>
        )
    }
}
export default MusicAlgoFooter


// WEBPACK FOOTER //
// ./src/MusicAlgoFooter/MusicAlgoFooter.js